/*
Author : Abaid ullah
Module: INVITATION
github: https://github.com/abaid
*/

import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiInstanceV2 } from '../../Apis/AxiosV2';
import axios from 'axios';
import {URL} from "../../Apis/Constants";
import {errorMsg} from "../../Apis/functions";
import apiInstance from "../../Apis/Axios";
const config = {
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded',
    },
};

const PUBLIC = 'public/'
const DELETE_INVITATION = 'invitation-service/delete-by-id';
const CREATE_INVITATION = 'invitation-service/v1/web/create';
const VALIDATE_VISITOR_STATUS = 'invitation-service/validate-visitor-invitation/'
const VALIDATE_STATUS = 'invitation-service/validate-invitation/'
const GET_SEARCH_BY_EMAIL = 'user-service/get-by-email';
const GET_SEARCH_BY_PHONE = 'user-service/get-by-phone-number';
const GET_SEARCH_VISITOR_TYPES = 'advanced-search-service/simple';
const COUNT_ALL_BY_ALL_STATUS = 'invitation-service/count-all/by-all-status/';
const REMOVE_USER_INVITATIONS = 'event-service/v1/remove-user-invitations';
const NOTIFY_HOST = 'invitation-service/notify-host';
const MARK_AS_READ = 'invitation-service/v1/notifications/mark-as-read';

// List all the invitation
export const GetAllInvitation = createAsyncThunk(
    'invitation/getAllInvitation',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .post(GET_SEARCH_VISITOR_TYPES, params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });

        const { data, status } = result;

        return { data, status };
    },
);

export const GetSearchUserService = createAsyncThunk(
    'invitation/getSearchUserService',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .get(`${params.type === 'email' ? GET_SEARCH_BY_EMAIL : GET_SEARCH_BY_PHONE}/${params.value}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });

        const { data, status } = result;

        return { data, status };
    },
);
// create invitation
export const CreateInvitation = createAsyncThunk(
    'invitation/createInvitation',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .post(CREATE_INVITATION, params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);
// submit invitation
export const SubmitInvitation = createAsyncThunk(
    'invitation/submitInvitation',
    async (formData, { dispatch, getState }) => {
        const result = await axios
            .put(`${URL}invitation-service/submit-fields/${formData.id}`, formData.aux)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);
// delete invitation
export const DeleteInvitation = createAsyncThunk(
    'invitation/deleteInvitation',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .delete(`${DELETE_INVITATION}/${params}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

export const GetInvitationById = createAsyncThunk(
    'invitation/getInvitationById',
    async (params) => {
        try {
            return await axios.get(`${URL}invitation-service/details-with-fields/${params}`, config);
        } catch (error) {
            if (!error.response) {
               errorMsg(error.response.status)
            }
            return { data: error.response.data, status: error.response.status };
        }
    },
);

export const CancelInvitation = createAsyncThunk(
    'invitation/cancelInvitation',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .put(`${REMOVE_USER_INVITATIONS}`, params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);


export const CountAllByAllStatus = createAsyncThunk(
    'invitation/countAllByAllStatus',
    async (userId, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .get(`${COUNT_ALL_BY_ALL_STATUS}${userId}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

export const UpdateVisitorStatusByInvitationId = createAsyncThunk(
    'invitation/updateVisitorStatusByInvitationId',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .put(`${VALIDATE_VISITOR_STATUS}${params?.invitationId}/option/${params?.statusId}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

export const GetInvitationHeadersByOption = createAsyncThunk(
    'invitation/getInvitationHeadersByOption',
    async (option, { dispatch, getState }) => {
        try {
            const response = await apiInstanceV2.get(`invitation-service/headers/${option}`);
            const { data, status } = response;
            return { data, status };
        } catch (error) {
            const { response } = error;
            return { data: response.data, status: response.status };
        }
    },
);

export const GetInvitationValuesByOptionFieldAndUserId = createAsyncThunk(
    'invitation/getInvitationValuesByOptionFieldAndUserId',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .get(`invitation-service/${params.field}/values-to-filter/to-user-id/${params.userId}/${params.viewType}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

export const UpdateStatusByInvitationId = createAsyncThunk(
    'invitation/updateStatusByInvitationId',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .put(`${VALIDATE_STATUS}${params?.invitationId}/option/${params?.option}/params/${params?.statusReason}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

export const publicUpdateStatusByInvitationId = createAsyncThunk(
    'invitation/publicUpdateStatusByInvitationId',
    async (params, { dispatch, getState }) => {
        try {
            return await axios.put(`${URL}invitation-service/${PUBLIC}validate-invitation/${params?.invitationId}/option/${params?.option}/params/${params?.statusReason}`)
        } catch (error) {
            if (!error.response) {
                errorMsg(error.response.status)
            }
            return { data: error.response.data, status: error.response.status };
        }
    },
);

export const PublicCreateUserFile = createAsyncThunk('invitation/publicCreateUserFile', async (params, { dispatch, getState }) => {
        try {
            return await axios.post(`${URL}user-service/${PUBLIC}user-file/create`, params);
        } catch (error) {
            if (!error.response) {
                errorMsg(error.response.status)
            }
            return { data: error.response.data, status: error.response.status };
        }
    },
);

export const PublicDeleteUserFile = createAsyncThunk('invitation/publicDeleteUserFile', async (params, { dispatch, getState }) => {
        try {
            return await axios.delete(`${URL}user-service/${PUBLIC}user-file/delete/${params}`);
        } catch (error) {
            if (!error.response) {
                errorMsg(error.response.status)
            }
            return { data: error.response.data, status: error.response.status };
        }
    },
);

export const PublicDeleteUserImageByUserAndAccessMethod = createAsyncThunk('invitation/PublicDeleteUserImageByUserAndAccessMethod',
    async ({userId, accessMethodId}, { dispatch, getState }) => {
        try {
            return await axios.delete(`${URL}user-service/${PUBLIC}user-image/delete/${userId}/${accessMethodId}`);
        } catch (error) {
            if (!error.response) {
                errorMsg(error.response.status)
            }
            return { data: error.response.data, status: error.response.status };
        }
    },
);

export const publicUpdateVisitorStatusByInvitationId = createAsyncThunk(
    'invitation/publicUpdateVisitorStatusByInvitationId',
    async (params, { dispatch, getState }) => {
        try {
            return await axios.put(`${URL}invitation-service/${PUBLIC}validate-visitor-invitation/${params?.invitationId}/option/${params?.statusId}`);
        } catch (error) {
            if (!error.response) {
                errorMsg(error.response.status)
            }
            return { data: error.response.data, status: error.response.status };
        }
    },
);

export const publicGenerateICSByInvitation = createAsyncThunk(
    'invitation/publicGenerateICSByInvitation',
    async (params, { dispatch, getState }) => {
        try {
            return await axios.put(`${URL}invitation-service/${PUBLIC}generate-ics/${params?.invitationId}/ics-action/${params?.action}`,null,{ responseType: 'blob' });
        } catch (error) {
            if (!error.response) {
                errorMsg(error.response.status)
            }
            return { data: error.response.data, status: error.response.status };
        }
    },
);

export const publicDeleteItemsById = createAsyncThunk(
    'invitation/publicDeleteItemsById',
    async (params, { dispatch, getState }) => {
        try {
            return await axios.post(
                `${URL}invitation-service/${PUBLIC}delete-by-ids`, params, { headers: { 'Content-Type': 'application/json' } }
            );
        } catch (error) {
            if (!error.response) {
                errorMsg(error.response.status);
            }
            return { data: error.response?.data, status: error.response?.status };
        }
    }
);

export const PublicGetQrCodeByUserId = createAsyncThunk(
    'invitation/publicGetQrCodeByUserId',
    async (params) => {
        try {
            return await axios.get(`${URL}user-service/${PUBLIC}qr-code/${params?.userId}/${params?.invitationId}`)
        } catch (error) {
            if (!error.response) {
                errorMsg(error.response.status)
            }
            return { data: error.response.data, status: error.response.status };
        }
    },
);

export const NotifyHost = createAsyncThunk(
    'invitation/notifyHost',
    async (id, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .put(`${NOTIFY_HOST}/${id}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

export const InvitationMarkFilesAsRead = createAsyncThunk('invitation/markFilesAsRead', async (body) => {
    const response = await apiInstance
        .post(`${MARK_AS_READ}`, body)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});


